import { createContext, useContext, useState, useEffect, useMemo } from "react";

const REVIEWS_PT = [
  {
    q: "Diogo, um profissional de excelência! Desde o primeiro minuto, sempre pronto a ajudar, a explicar e a auxiliar em qualquer dúvida. Graças a isso conseguimos adquirir a nossa primeira casa.",
    n: "Márcia Teixeira & Marco Bento",
    r: "Crédito Habitação - Aquisição",
  },
  {
    q: "Eu e a minha esposa estamos muito satisfeitos com o trabalho do Diogo. Foi nota 10/10. Passou-nos confiança quando precisávamos e ajudou em tudo que tínhamos dúvida.",
    n: "João Vitor Amorim",
    r: "Crédito Habitação - Aquisição",
  },
  {
    q: "Estou muito feliz com a prestação do Diogo. Muito profissional, eficiente, um serviço de primeira qualidade. Sempre confiante e segura com o Diogo como meu gestor. Recomendo a todos, um trabalho de excelência.",
    n: "Carla Lino",
    r: "Crédito Habitação - Aquisição",
  },
  {
    q: "Excelente profissional. Processo tratado do início ao fim com audácia e profissionalismo. Mais uma vez obrigado e recomendo!",
    n: "Sara Espírito Santo Vieira",
    r: "Crédito Habitação - Aquisição",
  },
  {
    q: "Como sempre, o Diogo foi um excelente profissional a tratar de todo o meu processo. Só tenho a dizer coisas excelentes do Diogo.",
    n: "Miguel Vieira",
    r: "Crédito Habitação - Aquisição",
  },
  {
    q: "Quero agradecer o excelente trabalho feito pelo Diogo, que me acompanhou nesta etapa tão importante da minha vida. É um excelente profissional. Faz um serviço de excelência.",
    n: "Tânia Glória",
    r: "Crédito Habitação - Aquisição",
  },
  {
    q: "Quero agradecer o excelente trabalho feito pelo amigo e colega Diogo. Tudo feito com grande celeridade e profissionalismo. Continua esse serviço de excelência que prestas a quem necessita.",
    n: "Hugo Canelhas",
    r: "Crédito Habitação - Transferência",
  },
  {
    q: "Quando nada nem ninguém acredita, o Diogo acredita. Homem de muito conhecimento, responsabilidade e de inteira confiança. Mexe todos os cordelinhos para que tudo corra pelo melhor.",
    n: "Daniela Santos",
    r: "Crédito Habitação - Aquisição",
  },
];

const REVIEWS_EN = [
  {
    q: "I had an excellent experience working with Diogo. He is exceptionally knowledgeable about Portuguese banks and the full range of loan structures. What can often be a confusing process felt organized and manageable because of his guidance.",
    n: "Michael Phillip Levine",
    r: "Mortgage - Home Purchase",
  },
  {
    q: "From our first conversation to completion, Diogo made the whole process effortless and stress-free. Thanks to his hard work I secured a fantastic mortgage deal. I would highly recommend him.",
    n: "Adam O'Neil",
    r: "Mortgage - Home Purchase",
  },
  {
    q: "We recently used Diogo for our mortgage, bank accounts and insurance — the service was fantastic. He took all the stress away and advised us on the best options available.",
    n: "Gemma O'Neil",
    r: "Mortgage - Home Purchase",
  },
  {
    q: "We worked with Diogo last year when purchasing our home in Lagos. He is very knowledgeable, professional and most of all personable. He has reached out periodically to check on us. Highly recommend!",
    n: "Chad Doughty",
    r: "Mortgage - Home Purchase",
  },
  {
    q: "Mr. Almeida proved to be the person we relied on most. He's loyal to his customers, works tirelessly and genuinely cares about you as a person. We feel blessed to have known him.",
    n: "Jean & Danielle Hamler",
    r: "Mortgage - Home Purchase",
  },
  {
    q: "Diogo was instrumental in our home purchasing process. He was a fantastic guardian of our financial well-being and made sure we were offered the best possible choices. A financial wizard to have in your corner.",
    n: "Yelena Wheeler",
    r: "Mortgage - Home Purchase",
  },
  {
    q: "Diogo demonstrated an impressive level of kindness, attentiveness, and knowledge that made the entire process smooth and enjoyable. His expertise in the local market was evident every step of the way.",
    n: "Stephanie Bosler",
    r: "Mortgage - Home Purchase",
  },
  {
    q: "Diogo was an absolute Godsend, who worked tirelessly to navigate us through a very complex process while researching and fighting to deliver the most competitive mortgage and insurance rates. We highly recommend him.",
    n: "Eric & Raechel Anderson",
    r: "Mortgage - Home Purchase",
  },
];

export const translations = {
  pt: {
    nav: {
      services: "Serviços",
      how: "Como Funciona",
      guide: "Guias",
      testimonials: "Testemunhos",
      faq: "FAQ",
      contact: "Contacto",
      cta: "Agendar Reunião",
    },
    hero: {
      badge: "Decisão Ordenada, Lda · Intermediário de Crédito Vinculado",
      title_1: "O crédito certo,",
      title_2: "sem custos para si.",
      lead: "Crédito Habitação com as Melhores Taxas do Mercado — 100% Gratuito",
      subtitle:
        "Comparo propostas de vários bancos, negoceio por si e encontro a melhor solução para crédito habitação, transferência de crédito ou renegociação — sem custos nem comissões.",
      cta_primary: "Agendar Reunião",
      cta_whatsapp: "Falar no WhatsApp",
      trust: ["Serviço 100% gratuito", "Resposta em 24h", "Atendimento personalizado"],
      recommend: "Avaliações no Google",
      role: "Diretor de Loja · Gestor de Crédito",
      available: "Disponível esta semana",
    },
    heroSim: {
      badge: "Simulador gratuito",
      title: "Simule a sua prestação",
      amount: "Montante do crédito",
      term: "Prazo",
      years: "anos",
      spread: "Spread",
      monthly: "Prestação estimada",
      perMonth: "/mês",
      rateNote: "TAN indicativa",
      euribor: "Euribor 6M",
      cta: "Pedir aprovação gratuita",
      disclaimer: "Simulação indicativa. Sujeita a análise bancária e condições de mercado.",
    },
    guides: {
      label: "Guia 2026",
      title: "Crédito habitação em Portugal: tudo o que precisa de saber",
      subtitle:
        "Taxas, spreads, Euribor, regra dos 45% (DSTI) e crédito para não residentes — explicado de forma simples para tomar a melhor decisão em 2026.",
      items: [
        {
          t: "Crédito habitação para não residentes e estrangeiros",
          d: "Financiamento até 80% do valor do imóvel (LTV) para não residentes que compram casa em Portugal, com todo o processo tratado em inglês ou português — do NIF à escritura.",
        },
        {
          t: "Transferência de crédito habitação",
          d: "Reduza o spread e a prestação mensal transferindo o seu crédito habitação para outro banco. Faço uma análise gratuita e comparo propostas para maximizar a sua poupança.",
        },
        {
          t: "Euribor, spread e TAEG explicados",
          d: "Entenda a diferença entre taxa variável (Euribor 6M/12M + spread), taxa mista e taxa fixa, e escolha a melhor opção de crédito habitação para o seu perfil em 2026.",
        },
        {
          t: "Regra dos 45% (DSTI) do Banco de Portugal",
          d: "A taxa de esforço máxima recomendada afeta a sua capacidade de crédito. Explico como é calculada e como estruturar o financiamento para ser aprovado.",
        },
        {
          t: "Documentos e prazos de aprovação",
          d: "IRS, recibos de vencimento, extratos bancários, NIF e mapa de responsabilidades de crédito. A análise de viabilidade demora apenas 2 a 3 dias.",
        },
        {
          t: "Melhores taxas de crédito habitação",
          d: "Comparo em simultâneo 10 bancos e 2 financeiras para encontrar o melhor spread, a melhor TAEG e as melhores condições — sem qualquer custo para si.",
        },
      ],
      cta: "Falar com o Diogo",
      readMore: "Artigos e guias",
      articles: [
        { t: "Crédito habitação para não residentes 2026", href: "/credito-habitacao-nao-residentes" },
        { t: "Taxa fixa, variável ou mista? Euribor e spread", href: "/taxa-fixa-variavel-euribor-spread" },
        { t: "Regra dos 45% (DSTI): quanto posso pedir", href: "/regra-45-dsti-taxa-esforco" },
        { t: "IMT e custos de comprar casa em Portugal", href: "/imt-custos-comprar-casa" },
        { t: "Seguro de vida do crédito: como poupar", href: "/seguro-vida-credito-habitacao" },
        { t: "Comprar casa com Golden Visa ou Visto D7", href: "/comprar-casa-golden-visa-d7" },
        { t: "Simulador vs. proposta real: porque muda", href: "/simulador-vs-proposta-real" },
        { t: "Comprar casa em leilão: guia passo a passo", href: "/comprar-casa-leilao" },
        { t: "Crédito habitação para recibos verdes", href: "/credito-habitacao-recibos-verdes" },
      ],
    },
    booking: {
      label: "Agenda",
      title: "Agende a sua reunião gratuita",
      subtitle:
        "Escolha o dia e a hora que lhe der mais jeito. Reunião online ou presencial, sem custos e sem compromisso.",
    },
    trust: {
      title: "Profissional. Transparente. Centrado em si.",
      subtitle:
        "Em 2025, as lojas da Decisão Ordenada, Lda — Faro, Albufeira, Quarteira, Montemor-o-Novo e Almancil — apoiaram 1.046 famílias com mais de €200M em crédito habitação. Eu acompanho o seu processo pessoalmente, do primeiro contacto à escritura.",
      metrics: {
        families: "Famílias apoiadas (Decisão Ordenada, 2025)",
        volume: "Contratados (Decisão Ordenada, 2025)",
        banks: "Bancos",
        financeiras: "Financeiras",
      },
      banksLabel: "Bancos e financeiras com quem trabalho",
    },
    services: {
      title: "Soluções premium de crédito habitação e seguros",
      subtitle:
        "Um único interlocutor para crédito habitação, transferência, renegociação e seguros — decisões claras, melhor taxa, melhores condições.",
      items: [
        {
          t: "Crédito Habitação",
          d: "Simulação e negociação completa de crédito habitação com os principais bancos — melhor taxa, melhor spread e melhor MTIC para comprar a sua próxima casa em Portugal.",
        },
        {
          t: "Transferência e Refinanciamento",
          d: "Transferência de crédito habitação e renegociação de spread: reduza a prestação mensal e poupe milhares de euros ao longo do contrato.",
        },
        {
          t: "Crédito para\nNão-Residentes",
          d: "Crédito habitação para não-residentes, estrangeiros e expats em Portugal. Documentação tratada em inglês ou português, do início à escritura.",
        },
        {
          t: "Equity Release",
          d: "Liberte o capital da sua casa para investir, renovar ou consolidar créditos com as melhores taxas do mercado.",
        },
        {
          t: "Seguro de Vida",
          d: "Seguro de vida associado ao crédito habitação: comparação independente das melhores apólices para proteger a sua família e a sua casa.",
        },
        {
          t: "Seguro de Saúde",
          d: "Seguro de saúde com acesso rápido a cuidados privados, com coberturas adequadas a si e à sua família.",
        },
      ],
    },
    how: {
      title: "Processo de crédito habitação simples, do princípio ao fim",
      steps: [
        {
          t: "Primeiro Contacto",
          d: "Conversamos sobre o seu projeto de compra, transferência ou renegociação — sem compromisso e sem qualquer custo.",
        },
        {
          t: "Análise & Estratégia",
          d: "Análise de viabilidade, enquadramento financeiro e definição da melhor estratégia de crédito habitação para o seu perfil.",
        },
        {
          t: "Apresentação das Propostas",
          d: "Apresento, lado a lado, as propostas de cada banco — TAEG, taxa, spread, MTIC, prestação e seguros.",
        },
        {
          t: "Aprovação & Escritura",
          d: "Acompanho aprovação, avaliação do imóvel e marcação da escritura. Você só assina onde indicado.",
        },
      ],
    },
    testimonials: {
      title: "Clientes que confiaram em mim",
      badge: "Avaliações no Google",
      seeMore: "Ver todas as avaliações no Google",
      items: REVIEWS_PT,
    },
    faq: {
      title: "Perguntas frequentes",
      items: [
        {
          q: "O serviço é mesmo gratuito?",
          a: "Sim. Sou remunerado pelo banco que vier a financiar o seu crédito — nunca por si. Independentemente da sua decisão final, não paga nada.",
        },
        {
          q: "Trabalha com todos os bancos?",
          a: "Trabalho com 10 bancos (Banco BPI, Santander, Caixa Geral de Depósitos, Novo Banco, Banco CTT, Bankinter, ABANCA, UCI, BNI Europa e Crédito Agrícola) e 2 financeiras (Cofidis e Cetelem). É a este painel que recorro para encontrar a melhor solução para si.",
        },
        {
          q: "Não-residentes podem pedir crédito habitação em Portugal?",
          a: "Sim. Tenho larga experiência com expats e investidores estrangeiros, especialmente no Algarve. Processo todo o crédito em português ou inglês, do primeiro contacto à escritura.",
        },
        {
          q: "Quanto tempo demora a aprovação?",
          a: "A análise de viabilidade leva entre 2 a 3 dias, após recebidos todos os documentos. Posteriormente, a aprovação da proposta escolhida pelo cliente leva igualmente 2 a 3 dias.",
        },
        {
          q: "Que documentos são necessários?",
          a: "Declaração anual de rendimentos (IRS), recibos de vencimento, extratos bancários, documento de identificação e NIF, mapa de responsabilidade de crédito (credit report). Enviarei uma lista completa após a primeira consulta, personalizada de acordo com o contexto pessoal, profissional e financeiro de cada cliente.",
        },
        {
          q: "Pode ajudar a refinanciar / transferir o meu crédito atual?",
          a: "Sim. Faço uma análise gratuita ao seu crédito habitação atual e comparo com propostas de outros bancos para encontrar a melhor poupança possível na prestação mensal e no custo total do contrato.",
        },
      ],
    },
    form: {
      title: "Vamos encontrar a melhor solução para si",
      subtitle:
        "Preencha o formulário e respondo-lhe em menos de 24h. Ou agende já uma reunião no calendário.",
      fields: {
        name: "Nome completo",
        email: "Email",
        phone: "Telemóvel",
        nationality: "Nacionalidade",
        residency: "Residente em Portugal?",
        residency_yes: "Residente",
        residency_no: "Não-residente",
        service: "Serviço de interesse",
        service_purchase: "Compra de habitação",
        service_refi: "Refinanciamento / Transferência",
        service_nr: "Crédito não-residente",
        service_equity: "Equity release",
        service_insurance: "Seguros",
        budget: "Valor pretendido (€)",
        property_found: "Já tem imóvel identificado?",
        urgency: "Quando quer avançar?",
        message: "Mensagem (opcional)",
      },
      submit: "Pedir análise gratuita",
      success: "Pedido recebido. Responde-lhe em menos de 24h.",
      error: "Algo correu mal. Tente novamente ou contacte por WhatsApp.",
      privacy: "Os seus dados são confidenciais e nunca partilhados.",
    },
    final: {
      title: "Vamos encontrar o melhor crédito para si.",
      subtitle: "Sem custos. Sem compromisso. Apenas resultados.",
      cta: "Agendar Reunião",
    },
    exit: {
      title: "Antes de ir embora...",
      subtitle:
        "Receba uma análise gratuita ao seu crédito habitação ou uma simulação de compra. Sem compromisso.",
      cta: "Quero a minha análise",
      dismiss: "Agora não",
    },
    footer: {
      tag: "Decisão Ordenada, Lda",
      rights: "Todos os direitos reservados.",
    },
  },
  en: {
    nav: {
      services: "Services",
      how: "How It Works",
      guide: "Guide",
      testimonials: "Reviews",
      faq: "FAQ",
      contact: "Contact",
      cta: "Book Meeting",
    },
    hero: {
      badge: "Decisão Ordenada, Lda · Tied Credit Intermediary",
      title_1: "The right credit,",
      title_2: "at no cost to you.",
      lead: "Mortgage in Portugal with the Best Market Rates — 100% Free",
      subtitle:
        "I compare proposals from multiple banks, negotiate on your behalf and find the best solution for your mortgage, mortgage transfer or renegotiation — with no fees and no commissions.",
      cta_primary: "Book a Meeting",
      cta_whatsapp: "Chat on WhatsApp",
      trust: ["100% free service", "Reply within 24h", "Personalised advisory"],
      recommend: "Google reviews",
      role: "Branch Manager · Mortgage Advisor",
      available: "Available this week",
    },
    heroSim: {
      badge: "Free estimator",
      title: "Estimate your payment",
      amount: "Loan amount",
      term: "Term",
      years: "years",
      spread: "Spread",
      monthly: "Estimated payment",
      perMonth: "/mo",
      rateNote: "Indicative rate",
      euribor: "Euribor 6M",
      cta: "Request free pre-approval",
      disclaimer: "Indicative estimate only. Subject to bank analysis and market conditions.",
    },
    guides: {
      label: "2026 Guide",
      title: "Mortgages in Portugal: everything you need to know",
      subtitle:
        "Rates, spreads, Euribor, the 45% (DSTI) rule and non-resident mortgages — explained simply so you can make the best decision in 2026.",
      items: [
        {
          t: "Mortgages for non-residents and foreigners",
          d: "Financing up to 80% of the property value (LTV) for non-residents buying a home in Portugal, with the entire process handled in English or Portuguese — from NIF to closing.",
        },
        {
          t: "Mortgage transfer & refinancing",
          d: "Lower your spread and monthly payment by transferring your mortgage to another bank. I run a free analysis and benchmark offers to maximise your savings.",
        },
        {
          t: "Euribor, spread and APRC explained",
          d: "Understand the difference between variable (Euribor 6M/12M + spread), mixed and fixed rates, and choose the best mortgage option for your profile in 2026.",
        },
        {
          t: "The Bank of Portugal 45% (DSTI) rule",
          d: "The maximum recommended effort rate affects how much you can borrow. I explain how it's calculated and how to structure financing to get approved.",
        },
        {
          t: "Documents and approval timelines",
          d: "Tax return, payslips, bank statements, NIF and credit liability report. The viability analysis takes just 2 to 3 days.",
        },
        {
          t: "Best mortgage rates in Portugal",
          d: "I compare 10 banks and 2 finance houses at once to find the best spread, best APRC and best conditions — at no cost to you.",
        },
      ],
      cta: "Talk to Diogo",
      readMore: "Articles & guides",
      articles: [
        { t: "Non-resident mortgages in Portugal 2026", href: "/credito-habitacao-nao-residentes" },
        { t: "Fixed, variable or mixed rate? Euribor & spread", href: "/taxa-fixa-variavel-euribor-spread" },
        { t: "The 45% (DSTI) rule: how much can I borrow", href: "/regra-45-dsti-taxa-esforco" },
        { t: "IMT & the costs of buying a home in Portugal", href: "/imt-custos-comprar-casa" },
        { t: "Mortgage life insurance: how to save", href: "/seguro-vida-credito-habitacao" },
        { t: "Buying a home with Golden Visa or D7 visa", href: "/comprar-casa-golden-visa-d7" },
        { t: "Estimator vs. real offer: why it changes", href: "/simulador-vs-proposta-real" },
        { t: "Buying a home at auction: step by step", href: "/comprar-casa-leilao" },
        { t: "Mortgages for self-employed (recibos verdes)", href: "/credito-habitacao-recibos-verdes" },
      ],
    },
    booking: {
      label: "Calendar",
      title: "Book your free meeting",
      subtitle:
        "Pick the day and time that works best for you. Online or in person, at no cost and no commitment.",
    },
    trust: {
      title: "Mortgage in Portugal, Negotiated for You. At No Cost.",
      subtitle:
        "In 2025, the Decisão Ordenada, Lda branches — Faro, Albufeira, Quarteira, Montemor-o-Novo and Almancil — supported 1,046 families with over €200M in mortgage credit. I personally handle your process from first contact to completion.",
      metrics: {
        families: "Families supported (Decisão Ordenada, 2025)",
        volume: "Financed (Decisão Ordenada, 2025)",
        banks: "Banks",
        financeiras: "Finance houses",
      },
      banksLabel: "Banks and finance houses I work with",
    },
    services: {
      title: "Premium mortgage & insurance solutions in Portugal",
      subtitle:
        "A single point of contact for mortgage, transfer, renegotiation and insurance — clear decisions, best rate, best conditions.",
      items: [
        {
          t: "Property Purchase",
          d: "Mortgage simulation and full negotiation with the leading Portuguese banks — best rate, best spread and best APRC to buy your next property in Portugal.",
        },
        {
          t: "Transfer & Refinancing",
          d: "Mortgage transfer and spread renegotiation: lower your monthly payment and save thousands over the loan term.",
        },
        {
          t: "Mortgage for\nNon-Residents",
          d: "Non-resident mortgage in Portugal for foreigners and expats. Full process handled in English or Portuguese, from first contact to closing.",
        },
        {
          t: "Equity Release",
          d: "Unlock the equity in your home to invest, renovate or consolidate debt at the best market rates.",
        },
        {
          t: "Life Insurance",
          d: "Mortgage life insurance: independent comparison of the best policies to protect your family and your home.",
        },
        {
          t: "Health Insurance",
          d: "Private health insurance with fast access to private healthcare and coverage tailored to you and your family.",
        },
      ],
    },
    how: {
      title: "A simple process, from start to finish",
      steps: [
        {
          t: "First Contact",
          d: "We talk about your project and goals — with no commitment and no cost.",
        },
        {
          t: "Analysis & Strategy",
          d: "Detailed analysis, financial profiling and definition of the best strategy for your case.",
        },
        {
          t: "Presentation of Proposals",
          d: "I present, side by side, the proposals each bank has for you — rate, spread, APRC and insurance.",
        },
        {
          t: "Approval & Closing",
          d: "I handle approval, property valuation and closing. You only sign where indicated.",
        },
      ],
    },
    testimonials: {
      title: "Clients who trusted me",
      badge: "Google reviews",
      seeMore: "See all reviews on Google",
      items: REVIEWS_EN,
    },
    faq: {
      title: "Frequently asked questions",
      items: [
        {
          q: "Is the service really free?",
          a: "Yes. I'm paid by the bank that ultimately finances your loan — never by you. Whatever you decide, you pay nothing.",
        },
        {
          q: "Do you work with all banks?",
          a: "I work with 10 banks (BPI, Santander, CGD, Novo Banco, Banco CTT, Bankinter, ABANCA, UCI, BNI Europa and Crédito Agrícola) and 2 finance houses (Cofidis and Cetelem). This is the panel I use to find your best solution.",
        },
        {
          q: "Can non-residents apply for a mortgage in Portugal?",
          a: "Yes. I have extensive experience with expats and foreign investors, especially in the Algarve. I handle the full process in English or Portuguese, from first contact to closing.",
        },
        {
          q: "How long does approval take?",
          a: "Viability analysis takes 2 to 3 days once all documents are received. Final approval of the chosen offer takes another 2 to 3 days.",
        },
        {
          q: "What documents are needed?",
          a: "Annual tax return (IRS), payslips, bank statements, ID and tax number (NIF), and the credit liability map (credit report). I'll send a complete list after the first consultation, tailored to each client's personal, professional and financial context.",
        },
        {
          q: "Can you help refinance / transfer my current mortgage?",
          a: "Absolutely. I'll do a free analysis of your current mortgage and benchmark it against other banks' offers to find the best possible saving on monthly payment and total cost.",
        },
      ],
    },
    form: {
      title: "Let's find the best solution for you",
      subtitle:
        "Fill in the form and I'll reply within 24h. Or book a meeting directly on the calendar.",
      fields: {
        name: "Full name",
        email: "Email",
        phone: "Phone",
        nationality: "Nationality",
        residency: "Resident in Portugal?",
        residency_yes: "Resident",
        residency_no: "Non-resident",
        service: "Service of interest",
        service_purchase: "Property purchase",
        service_refi: "Refinancing / Transfer",
        service_nr: "Non-resident mortgage",
        service_equity: "Equity release",
        service_insurance: "Insurance",
        budget: "Target amount (€)",
        property_found: "Have you found a property?",
        urgency: "When do you want to proceed?",
        message: "Message (optional)",
      },
      submit: "Request free analysis",
      success: "Request received. I'll be in touch within 24h.",
      error: "Something went wrong. Please try again or message me on WhatsApp.",
      privacy: "Your information is confidential and never shared.",
    },
    final: {
      title: "Let's find the best mortgage for you.",
      subtitle: "No cost. No commitment. Just results.",
      cta: "Book Meeting",
    },
    exit: {
      title: "Before you go...",
      subtitle: "Get a free analysis of your mortgage or purchase simulation. No commitment.",
      cta: "Get my analysis",
      dismiss: "Not now",
    },
    footer: {
      tag: "Decisão Ordenada, Lda",
      rights: "All rights reserved.",
    },
  },
};

const I18nCtx = createContext({ lang: "pt", setLang: () => {}, t: translations.pt });

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "pt";
    return window.location.pathname.startsWith("/en") ? "en" : "pt";
  });
  useEffect(() => {
    window.localStorage.setItem("lang", lang);
    const p = window.location.pathname;
    if (p === "/" || p === "/en" || p === "/en/") {
      const target = lang === "en" ? "/en" : "/";
      if (p !== target) window.history.replaceState(null, "", target + window.location.hash);
    }
    document.documentElement.lang = lang;
  }, [lang]);
  const value = useMemo(
    () => ({ lang, setLang, t: translations[lang] }),
    [lang]
  );
  return (
    <I18nCtx.Provider value={value}>{children}</I18nCtx.Provider>
  );
};

export const useI18n = () => useContext(I18nCtx);
